import request from '@/utils/zsm-requets'
const good = '/zsm/api/good/'
import Qs from 'qs'
/**
 * 新建一个课程
@param auditDesc	审核说明
@param auditProgress	审核状态
@param bindTitle	挂载标题
@param buyCount	购买数
@param childAudit	章节待审核数
@param childCount	章节数
@param classifyFullName	完整分类名称
@param cloudCode	云盘提取码
@param cloudDict	云盘类型
@param cloudUrl	云盘地址
@param commentCount	评论数
@param contentCover	详情封面
@param cover	列表封面
@param defendFlag	防截屏
@param distCustomFlag	是否分销
@param hotCount	热度
@param mixContent	图文内容
@param platformDicts	审核说明
@param price	单价
@param publicFlag	上架标记
@param subTitle	副标题
@param title	标题
@param frontId	前端id
@param shopId	 门店id
@param sort	 排序
@param progress	 审核状态

 **/

export function createGood(params) {
  return request({
    url: good + 'create',
    method: 'post',
    data: Qs.stringify(params)
    // headers:{'Content-Type':'application/x-www-form-urlencoded'}
    // params
  })
}

/** 删除Qs课程
@param id		课程id	 **/
export function deleteGood(id) {
  return request({
    url: good + 'delete',
    method: 'post',
    params: {
      id
    }
  })
}

/*
  修改上下架
  id 课程id
  shelfFlag 上下架

 */
export function updateShelfFlag(params) {
  return request({
    url: good + 'updateShelfFlag',
    method: 'post',
    params
  })
}

/** 查看课程的章节
@param id		课程id	 **/
export function listChildrenGood(params) {
  return request({
    url: good + 'listChildren',
    method: 'post',
    params
    // :{'goodId.id':id}
  })
}

/** 获取课程列表
@param auditDesc	审核说明
@param auditProgress	审核状态
@param bindTitle	挂载标题
@param buyCount	购买数
@param childAudit	章节待审核数
@param childCount	章节数
@param classifyFullName	完整分类名称
@param cloudCode	云盘提取码
@param cloudDict	云盘类型
@param cloudUrl	云盘地址
@param commentCount	评论数
@param contentCover	详情封面
@param cover	列表封面
@param defendFlag	防截屏
@param distCustomFlag	是否分销
@param hotCount	热度
@param mixContent	图文内容
@param platformDicts	审核说明
@param price	单价
@param publicFlag	上架标记
@param subTitle	副标题
@param title	标题
@param frontId	前端id
@param shopId	 门店id
@param sort	 排序
@param progress	 审核状态
 **/
export function listDataGood(params) {
  return request({
    url: good + 'listData',
    method: 'post',
    params
  })
}

/** 查看课程的分组
@param id		课程id	 **/
export function listGroupGood(tempGoodId) {
  return request({
    url: good + 'listGroup',
    method: 'post',
    params: {
      tempGoodId,
      pageSize: 999
    }
  })
}

// 修改一个课程
/**
@param auditDesc	审核说明
@param auditProgress	审核状态
@param bindTitle	挂载标题
@param buyCount	购买数
@param childAudit	章节待审核数
@param childCount	章节数
@param classifyFullName	完整分类名称
@param cloudCode	云盘提取码
@param cloudDict	云盘类型
@param cloudUrl	云盘地址
@param commentCount	评论数
@param contentCover	详情封面
@param cover	列表封面
@param defendFlag	防截屏
@param distCustomFlag	是否分销
@param hotCount	热度
@param mixContent	图文内容
@param platformDicts	审核说明
@param price	单价
@param publicFlag	上架标记
@param subTitle	副标题
@param title	标题
@param frontId	前端id
@param shopId	 门店id
@param sort	 排序
@param progress	 审核状态
 **/
export function updateGood(params) {
  return request({
    url: good + 'update',
    method: 'post',
    data: Qs.stringify(params)
  })
}

// 获取课程 id课程id  viewFlag是否增加观看数
export function getGood(id) {
  return request({
    url: good + 'get',
    method: 'post',
    params: {
      viewFlag: 0,
      id
    }
  })
}

// 创建分组  goodId课程id   name内容
export function createGroup(tempGoodId, name, sort) {
  return request({
    url: good + 'createGroup',
    method: 'post',
    params: {
      tempGoodId,
      name,
      sort
    }
  })
}

// 删除分组  id分组id
export function deleteGroup(id) {
  return request({
    url: good + 'deleteGroup',
    method: 'post',
    params: {
      id
    }
  })
}

// 修改分组
export function updateGroup(params) {
  return request({
    url: good + 'updateGroup',
    method: 'post',
    params
  })
}

// 修改版权内容 copyRightNote版权内容 id课程id
export function updateCopyRight(copyRightNote, id) {
  return request({
    url: good + 'updateCopyRight',
    method: 'post',
    params: {
      copyRightNote,
      id
    }
  })
}

/**
  * 创建章节
  * @param goodGroupId 分组编号
  * @param goodGroupName 分组名称
  * @param tempGoodId 商品id
  * @param title 标题
  * @param mediaDict 媒体类型
  * @param mediaUrl 	媒体地址
  * @param shelfFlag 	上下架,0=下架，1=上架
  * @param auditProgress 审核状态
  * @param sort 分组名称
 */
export function createDetail(params) {
  return request({
    url: good + 'createDetail',
    method: 'post',
    data: Qs.stringify(params)
  })
}

/**
  * 修改章节
  * @param goodGroupId 分组编号
  * @param goodGroupName 分组名称
  * @param tempGoodId 商品id
  * @param title 标题
  * @param mediaDict 媒体类型
  * @param mediaUrl 	媒体地址
  * @param shelfFlag 	上下架,0=下架，1=上架
  * @param auditProgress 审核状态
  * @param sort 分组名称
 */
export function updateDetail(params) {
  return request({
    url: good + 'updateDetail',
    method: 'post',
    data: Qs.stringify(params)
  })
}

// 修改章节排序 sort 排序 id章节
export function updateDetailSort(params) {
  return request({
    url: good + 'updateDetailSort',
    method: 'post',
    params
  })
}

// 删除章节 id 章节id
export function deleteDetail(id) {
  return request({
    url: good + 'deleteDetail',
    method: 'post',
    params: {
      id
    }
  })
}

// 修改章节上下架 id 章节id  shelfFlag是否上架
export function updateDetailShelfFlag(id, shelfFlag) {
  return request({
    url: good + 'updateDetailShelfFlag',
    method: 'post',
    params: {
      id,
      shelfFlag
    }
  })
}

// 批量更新分组排序 ids	商品分组编号，用逗号隔开
export function updateGroupSorts(ids) {
  return request({
    url: good + 'updateGroupSorts',
    method: 'post',
    params: {
      ids
    }
  })
}

// 修改章节的是否试看  demoFlag是否试看  id课程编号
export function updateDetailDemoFlag(params) {
  return request({
    url: good + 'updateDetailDemoFlag',
    method: 'post',
    params
  })
}

/**
* 修改章节的分组
* @param  groupId 分组id
* @param   groupName 分组名称
* @param   id  课程id
*/
export function updateDetailGroup(params) {
  return request({
    url: good + 'updateDetailGroup',
    method: 'post',
    params
  })
}

/**
 * 批量提交章节
 * @param detailIds 课程详情id
 * @param goodId 课程id
 * @returns
 */
export function batchUpdateDetail(params) {
  return request({
    url: good + 'batchUpdateDetail',
    method: 'post',
    params
  })
};

// 商品的各种选项
export function selectOption(params) {
  return request({
    url: good + 'selectOption',
    method: 'post',
    params
  })
}

// 修改课程排序
export function updateSort(params) {
  return request({
    url: good + 'updateSort',
    method: 'post',
    params
  })
}

/**
 * 复制到单个平台
 * @param goodId 商品id
 * @param targetPlatform  目标平台
 */
export function copyGood(params) {
  return request({
    url: good + 'copy',
    method: 'post',
    params
  })
}

/* 复制到多个平台
 * goodId 商品id
 * targetPlatforms  目标平台
 * */
export function copyToPlatforms(params) {
  return request({
    url: good + 'copyToPlatforms',
    method: 'post',
    params
  })
}
/**
 * 批量修改章节分组
 * @param groupId 分组ID
 * @param groupName  分组昵称
 * @param goodDetailId  商品ID列表
 */
export function updateGoodDetailId(params) {
  return request({
    url: good + 'updateGoodDetailId',
    method: 'post',
    params
  })
}

/** 发布视频号文章
 * @param goodId 商品id
 */
export function createArticleForOneGood(params) {
  return request({
    url: good + 'createArticleForOneGood',
    method: 'post',
    params
  })
}

// test接口  =》公众号发布文章
export function saveTheDraft(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: '/api/shipinhao/saveTheDraft',
    method: 'post',
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/**
 * 生成抖音小程序二维码
 * @param path 小程序二维码地址
 */
export function createAuthQrCode(path) {
  return request({
    url: good + 'createAuthQrCode',
    method: 'post',
    params: {
      path
    }
  })
}
/**
 * 保存课程的观看条件
 * @param goodId 课程Id
 * @param goodDetails 选择的章节Id，用，拼接
 * @param conditionsFlag 是否开启学习条件
 * @param studySecs 图文开启条件
 */
export function updateGoodDetailLookFlag(params) {
  return request({
    url: good + 'updateGoodDetailLookFlag',
    method: 'post',
    params
  })
}
/**
 * 查看课程的观看条件
 * @param  goodId 商品Id
 */
export function findGoodDetailLookFlag(goodId) {
  return request({
    url: good + 'findGoodDetailLookFlag',
    method: 'get',
    params: {
      goodId
    }
  })
}

/**
 * 修改商品划线价
 * @param {*} goodId
 * @param {*} crossedPrice
 * @returns
 */
export function updateGoodCrossedPrice(goodId, crossedPrice) {
  return request({
    url: good + 'updateGoodCrossedPrice',
    method: 'post',
    params: {
      goodId, crossedPrice
    }
  })
}


// 查询快手IOS商品价格档位
export function findKuaishouGoodPrice() {
  return request({
    url: good + 'findKuaishouGoodPrice',
    method: 'get',
  })
}
